/** Derived from ABF fillable PDF; labels humanised for the editor. */
import page2Fields from "./systemCardPage2Fields.json";

export const ABF_CARD_SECTIONS = [
  {
    id: "sec_1",
    title: "ABF Nos., names & basic system",
    items: [
      { pdfField: "Date_A", label: "Date", multiline: true },
      { pdfField: "Q_Brown", label: "Sticker / colour — Brown", multiline: true },
      { pdfField: "Q_Green", label: "Sticker / colour — Green", multiline: true },
      { pdfField: "Q_Blue", label: "Sticker / colour — Blue", multiline: true },
      { pdfField: "Q_Red", label: "Sticker / colour — Red", multiline: true },
      { pdfField: "Q_Yellow", label: "Sticker / colour — Yellow", multiline: true },
      { pdfField: "Classification", label: "Brown sticker classification (text)", multiline: true },
      { pdfField: "IsBrownSticker", label: "Brown sticker (yes/no or note)", multiline: true },
      { pdfField: "PlayerNo_A", label: "Player A — ABF number", multiline: true },
      { pdfField: "PlayerName_A", label: "Player A — name", multiline: true },
      { pdfField: "PlayerNo_B", label: "Player B — ABF number", multiline: true },
      { pdfField: "PlayerName_B", label: "Player B — name", multiline: true },
      { pdfField: "BasicSystem", label: "Basic system", multiline: true },
    ],
  },
  {
    id: "sec_2",
    title: "1. OPENING BIDS",
    items: [
      { pdfField: "Open1C", label: "1♣", multiline: true },
      { pdfField: "Open1D", label: "1♦", multiline: true },
      { pdfField: "Open1H", label: "1♥", multiline: true },
      { pdfField: "Open1S", label: "1♠", multiline: true },
      { pdfField: "Open1NT", label: "1NT", multiline: true },
      { pdfField: "Resp1NT2CStyle", label: "1NT Responses 2♣", multiline: true },
      { pdfField: "Resp1NT2D", label: "2♦", multiline: true },
      { pdfField: "Resp1NT2H", label: "2♥", multiline: true },
      { pdfField: "Resp1NT2S", label: "2♠", multiline: true },
      { pdfField: "Resp1NT2NT", label: "2NT", multiline: true },
      { pdfField: "Resp1NTDoubled", label: "(Dbl)", multiline: true },
      { pdfField: "Resp1NTOther", label: "other", multiline: true },
      { pdfField: "Open2C", label: "2♣", multiline: true },
      { pdfField: "Open2D", label: "2♦", multiline: true },
      { pdfField: "Open2H", label: "2♥", multiline: true },
      { pdfField: "Open2S", label: "2♠", multiline: true },
      { pdfField: "Open2NT", label: "2NT", multiline: true },
      { pdfField: "Open3NT", label: "3NT", multiline: true },
      { pdfField: "OpenOther", label: "other", multiline: true },
    ],
  },
  {
    id: "sec_3",
    title: "2. PRE-ALERTS",
    items: [
      { pdfField: "PreAlert_0", label: "Pre-alert — PreAlert_0", multiline: true },
      { pdfField: "PreAlert_1_1", label: "Pre-alert — PreAlert_1_1", multiline: true },
      { pdfField: "PreAlert_2_1", label: "Pre-alert — PreAlert_2_1", multiline: true },
      { pdfField: "PreAlert_1_2", label: "Pre-alert — PreAlert_1_2", multiline: true },
      { pdfField: "PreAlert_2_2", label: "Pre-alert — PreAlert_2_2", multiline: true },
      { pdfField: "PreAlert_1_3", label: "Pre-alert — PreAlert_1_3", multiline: true },
      { pdfField: "PreAlert_2_3", label: "Pre-alert — PreAlert_2_3", multiline: true },
    ],
  },
  {
    id: "sec_4",
    title: "3. COMPETITIVE BIDS / OVERCALLS",
    items: [
      { pdfField: "Competitive_0", label: "Competitive bids", multiline: true },
      { pdfField: "Doubles_1", label: "Doubles", multiline: true },
      { pdfField: "NegXLimit", label: "Negative double through", multiline: true },
      { pdfField: "Doubles_2", label: "Responsive doubles", multiline: true },
      { pdfField: "RespXLimit", label: "Responsive through", multiline: true },
      { pdfField: "JumpOvercall", label: "Jump overcalls", multiline: true },
      { pdfField: "UnusualNT", label: "Unusual NT", multiline: true },
      { pdfField: "Overcall1NT", label: "1NT overcall (immediate)", multiline: true },
      { pdfField: "Reopen1NT", label: "1NT overcall (re-opening)", multiline: true },
      { pdfField: "ImmedCueMinor", label: "Immediate cue bid — minor", multiline: true },
      { pdfField: "ImmedCueMajor", label: "Immediate cue bid — major", multiline: true },
      { pdfField: "CompeteWeak2", label: "Over weak twos", multiline: true },
      { pdfField: "CompeteOpen3", label: "Opening threes", multiline: true },
      { pdfField: "Transfers_1", label: "Opponent's transfers", multiline: true },
      { pdfField: "Compete1NT_1", label: "Opponent's 1NT", multiline: true },
      { pdfField: "Compete1NT_2", label: "Opponent's 1NT (cont.)", multiline: true },
      { pdfField: "Compete1NT_3", label: "Opponent's 1NT (cont.)", multiline: true },
    ],
  },
  {
    id: "sec_5",
    title: "4. BASIC RESPONSES",
    items: [
      { pdfField: "BasicResponses_0", label: "Basic responses (general)", multiline: true },
      { pdfField: "JumpRaiseMinor", label: "Jump raises - minors", multiline: true },
      { pdfField: "JumpRaiseMajor", label: "Jump raises - majors", multiline: true },
      { pdfField: "MinorJumpShift", label: "Jump shifts after minor opening", multiline: true },
      { pdfField: "MajorJumpShift", label: "Jump shifts after major opening", multiline: true },
      { pdfField: "ResponseStrong2", label: "Responses to strong 2 open", multiline: true },
      { pdfField: "Response2NT", label: "Responses to 2NT opening", multiline: true },
      { pdfField: "Resp1C_1D", label: "After 1♣ — 1D response", multiline: true },
      { pdfField: "Resp1C_1H", label: "After 1♣ — 1H response", multiline: true },
      { pdfField: "Resp1C_1S", label: "After 1♣ — 1S response", multiline: true },
      { pdfField: "Resp1C_1NT", label: "After 1♣ — 1NT response", multiline: true },
      { pdfField: "Resp1C_2C", label: "After 1♣ — 2C response", multiline: true },
      { pdfField: "Resp1C_2D", label: "After 1♣ — 2D response", multiline: true },
      { pdfField: "Resp1C_2H", label: "After 1♣ — 2H response", multiline: true },
      { pdfField: "Resp1C_2S", label: "After 1♣ — 2S response", multiline: true },
      { pdfField: "Resp1C_2NT", label: "After 1♣ — 2NT response", multiline: true },
      { pdfField: "Resp1C_3C", label: "After 1♣ — 3C response", multiline: true },
      { pdfField: "Resp1C_3D", label: "After 1♣ — 3D response", multiline: true },
      { pdfField: "Resp1C_3H", label: "After 1♣ — 3H response", multiline: true },
      { pdfField: "Resp1C_3S", label: "After 1♣ — 3S response", multiline: true },
      { pdfField: "Resp1C_3NT", label: "After 1♣ — 3NT response", multiline: true },
      { pdfField: "Resp1C_4C", label: "After 1♣ — 4C response", multiline: true },
      { pdfField: "Resp1C_Other", label: "After 1♣ — Other response", multiline: true },
      { pdfField: "Resp1D_1H", label: "After 1♦ — 1H response", multiline: true },
      { pdfField: "Resp1D_1S", label: "After 1♦ — 1S response", multiline: true },
      { pdfField: "Resp1D_1NT", label: "After 1♦ — 1NT response", multiline: true },
      { pdfField: "Resp1D_2C", label: "After 1♦ — 2C response", multiline: true },
      { pdfField: "Resp1D_2D", label: "After 1♦ — 2D response", multiline: true },
      { pdfField: "Resp1D_2H", label: "After 1♦ — 2H response", multiline: true },
      { pdfField: "Resp1D_2S", label: "After 1♦ — 2S response", multiline: true },
      { pdfField: "Resp1D_2NT", label: "After 1♦ — 2NT response", multiline: true },
      { pdfField: "Resp1D_3C", label: "After 1♦ — 3C response", multiline: true },
      { pdfField: "Resp1D_3D", label: "After 1♦ — 3D response", multiline: true },
      { pdfField: "Resp1D_3H", label: "After 1♦ — 3H response", multiline: true },
      { pdfField: "Resp1D_3S", label: "After 1♦ — 3S response", multiline: true },
      { pdfField: "Resp1D_3NT", label: "After 1♦ — 3NT response", multiline: true },
      { pdfField: "Resp1D_4C", label: "After 1♦ — 4C response", multiline: true },
      { pdfField: "Resp1D_4D", label: "After 1♦ — 4D response", multiline: true },
      { pdfField: "Resp1D_Other", label: "After 1♦ — Other response", multiline: true },
      { pdfField: "Resp1H_1S", label: "After 1♥ — 1S response", multiline: true },
      { pdfField: "Resp1H_1NT", label: "After 1♥ — 1NT response", multiline: true },
      { pdfField: "Resp1H_2C", label: "After 1♥ — 2C response", multiline: true },
      { pdfField: "Resp1H_2D", label: "After 1♥ — 2D response", multiline: true },
      { pdfField: "Resp1H_2H", label: "After 1♥ — 2H response", multiline: true },
      { pdfField: "Resp1H_2S", label: "After 1♥ — 2S response", multiline: true },
      { pdfField: "Resp1H_2NT", label: "After 1♥ — 2NT response", multiline: true },
      { pdfField: "Resp1H_3C", label: "After 1♥ — 3C response", multiline: true },
      { pdfField: "Resp1H_3D", label: "After 1♥ — 3D response", multiline: true },
      { pdfField: "Resp1H_3H", label: "After 1♥ — 3H response", multiline: true },
      { pdfField: "Resp1H_3S", label: "After 1♥ — 3S response", multiline: true },
      { pdfField: "Resp1H_3NT", label: "After 1♥ — 3NT response", multiline: true },
      { pdfField: "Resp1H_Other", label: "After 1♥ — Other response", multiline: true },
      { pdfField: "Resp1S_1NT", label: "After 1♠ — 1NT response", multiline: true },
      { pdfField: "Resp1S_2C", label: "After 1♠ — 2C response", multiline: true },
      { pdfField: "Resp1S_2D", label: "After 1♠ — 2D response", multiline: true },
      { pdfField: "Resp1S_2H", label: "After 1♠ — 2H response", multiline: true },
      { pdfField: "Resp1S_2S", label: "After 1♠ — 2S response", multiline: true },
      { pdfField: "Resp1S_2NT", label: "After 1♠ — 2NT response", multiline: true },
      { pdfField: "Resp1S_3C", label: "After 1♠ — 3C response", multiline: true },
      { pdfField: "Resp1S_3D", label: "After 1♠ — 3D response", multiline: true },
      { pdfField: "Resp1S_3H", label: "After 1♠ — 3H response", multiline: true },
      { pdfField: "Resp1S_3S", label: "After 1♠ — 3S response", multiline: true },
      { pdfField: "Resp1S_3NT", label: "After 1♠ — 3NT response", multiline: true },
      { pdfField: "Resp1S_4C", label: "After 1♠ — 4C response", multiline: true },
      { pdfField: "Resp1S_Other", label: "After 1♠ — Other response", multiline: true },
      { pdfField: "Resp2C_2D", label: "After 2♣ — 2D", multiline: true },
      { pdfField: "Resp2C_2H", label: "After 2♣ — 2H", multiline: true },
      { pdfField: "Resp2C_2S", label: "After 2♣ — 2S", multiline: true },
      { pdfField: "Resp2C_2NT", label: "After 2♣ — 2NT", multiline: true },
      { pdfField: "Resp2C_3C", label: "After 2♣ — 3C", multiline: true },
      { pdfField: "Resp2C_3D", label: "After 2♣ — 3D", multiline: true },
      { pdfField: "Resp2C_3H", label: "After 2♣ — 3H", multiline: true },
      { pdfField: "Resp2C_3S", label: "After 2♣ — 3S", multiline: true },
      { pdfField: "Resp2C_3NT", label: "After 2♣ — 3NT", multiline: true },
      { pdfField: "Resp2C_Other", label: "After 2♣ — Other", multiline: true },
      { pdfField: "Resp2D_2H", label: "After 2♦ — 2H", multiline: true },
      { pdfField: "Resp2D_2S", label: "After 2♦ — 2S", multiline: true },
      { pdfField: "Resp2D_2NT", label: "After 2♦ — 2NT", multiline: true },
      { pdfField: "Resp2D_3C", label: "After 2♦ — 3C", multiline: true },
      { pdfField: "Resp2D_3D", label: "After 2♦ — 3D", multiline: true },
      { pdfField: "Resp2D_3H", label: "After 2♦ — 3H", multiline: true },
      { pdfField: "Resp2D_3S", label: "After 2♦ — 3S", multiline: true },
      { pdfField: "Resp2D_3NT", label: "After 2♦ — 3NT", multiline: true },
      { pdfField: "Resp2D_4C", label: "After 2♦ — 4C", multiline: true },
      { pdfField: "Resp2D_Other", label: "After 2♦ — Other", multiline: true },
      { pdfField: "ResponseNotes_1", label: "Response notes (ResponseNotes_1)", multiline: true },
      { pdfField: "ResponseNotes_2", label: "Response notes (ResponseNotes_2)", multiline: true },
      { pdfField: "ResponseNotes_3", label: "Response notes (ResponseNotes_3)", multiline: true },
      { pdfField: "Resp2H_2S", label: "After 2♥ — 2S", multiline: true },
      { pdfField: "Resp2H_2NT", label: "After 2♥ — 2NT", multiline: true },
      { pdfField: "Resp2H_3C", label: "After 2♥ — 3C", multiline: true },
      { pdfField: "Resp2H_3D", label: "After 2♥ — 3D", multiline: true },
      { pdfField: "Resp2H_3H", label: "After 2♥ — 3H", multiline: true },
      { pdfField: "Resp2H_3S", label: "After 2♥ — 3S", multiline: true },
      { pdfField: "Resp2H_3NT", label: "After 2♥ — 3NT", multiline: true },
      { pdfField: "Resp2H_4C", label: "After 2♥ — 4C", multiline: true },
      { pdfField: "Resp2H_4H", label: "After 2♥ — 4H", multiline: true },
      { pdfField: "Resp2H_Other", label: "After 2♥ — Other", multiline: true },
      { pdfField: "Resp2S_2NT", label: "After 2♠ — 2NT", multiline: true },
      { pdfField: "Resp2S_3C", label: "After 2♠ — 3C", multiline: true },
      { pdfField: "Resp2S_3D", label: "After 2♠ — 3D", multiline: true },
      { pdfField: "Resp2S_3H", label: "After 2♠ — 3H", multiline: true },
      { pdfField: "Resp2S_3S", label: "After 2♠ — 3S", multiline: true },
      { pdfField: "Resp2S_3NT", label: "After 2♠ — 3NT", multiline: true },
      { pdfField: "Resp2S_4C", label: "After 2♠ — 4C", multiline: true },
      { pdfField: "Resp2S_4H", label: "After 2♠ — 4H", multiline: true },
      { pdfField: "Resp2S_4S", label: "After 2♠ — 4S", multiline: true },
      { pdfField: "Resp2S_Other", label: "After 2♠ — Other", multiline: true },
      { pdfField: "Resp2NT_3C", label: "After 2NT — 3C", multiline: true },
      { pdfField: "Resp2NT_3D", label: "After 2NT — 3D", multiline: true },
      { pdfField: "Resp2NT_3H", label: "After 2NT — 3H", multiline: true },
      { pdfField: "Resp2NT_3S", label: "After 2NT — 3S", multiline: true },
      { pdfField: "Resp2NT_3NT", label: "After 2NT — 3NT", multiline: true },
      { pdfField: "Resp2NT_4C", label: "After 2NT — 4C", multiline: true },
      { pdfField: "Resp2NT_4D", label: "After 2NT — 4D", multiline: true },
      { pdfField: "Resp2NT_4H", label: "After 2NT — 4H", multiline: true },
      { pdfField: "Resp2NT_4S", label: "After 2NT — 4S", multiline: true },
      { pdfField: "Resp2NT_Other", label: "After 2NT — Other", multiline: true },
      { pdfField: "JumpRaiseMinorOther", label: "Jump Raise Minor Other", multiline: true },
      { pdfField: "JumpRaiseMajorOther", label: "Jump Raise Major Other", multiline: true },
    ],
  },
  {
    id: "sec_6",
    title: "5. PLAY CONVENTIONS",
    items: [
      { pdfField: "PlayConventions_0", label: "Show priorities", multiline: true },
      { pdfField: "SeqLead_S", label: "Leads: Sequences (Suit)", multiline: true },
      { pdfField: "SeqLead_NT", label: "Leads: Sequences (NoTrump)", multiline: true },
      { pdfField: "FourHonourLead_S", label: "Four or more with an honour (Suit)", multiline: true },
      { pdfField: "FourHonourLead_NT", label: "Four or more with an honour (NoTrump)", multiline: true },
      { pdfField: "FourSmallLead_S", label: "From 4 small (Suit)", multiline: true },
      { pdfField: "FourSmallLead_NT", label: "From 4 small (NoTrump)", multiline: true },
      { pdfField: "ThreeSmallLead_S", label: "From 3 cards (no honour) (Suit)", multiline: true },
      { pdfField: "ThreeSmallLead_NT", label: "From 3 cards (no honour) (NoTrump)", multiline: true },
      { pdfField: "LeadPartnersSuit_S", label: "In partner's suit (Suit)", multiline: true },
      { pdfField: "LeadPartnersSuit_NT", label: "In partner's suit (NoTrump)", multiline: true },
      { pdfField: "DiscardType_S", label: "Discards (Suit)", multiline: true },
      { pdfField: "DiscardType_NT", label: "Discards (NoTrump)", multiline: true },
      { pdfField: "CountType_S", label: "count (Suit)", multiline: true },
      { pdfField: "CountType_NT", label: "count (NoTrump)", multiline: true },
      { pdfField: "SignalPartnerLead_S", label: "Signal on partner's lead (Suit)", multiline: true },
      { pdfField: "SignalPartnerLead_NT", label: "Signal on partner's lead (NoTrump)", multiline: true },
      { pdfField: "SignalDeclarerLead", label: "Signal on declarer's lead", multiline: true },
      { pdfField: "PlayNotes_1", label: "Notes 1", multiline: true },
      { pdfField: "PlayNotes_2", label: "Notes 2", multiline: true },
      { pdfField: "PlayNotes_3", label: "Notes 3", multiline: true },
    ],
  },
  {
    id: "sec_7",
    title: "6. SLAM CONVENTIONS",
    items: [
      { pdfField: "GerberWhen", label: "4C Gerber", multiline: true },
      { pdfField: "RKCBStyle", label: "RKCB", multiline: true },
      { pdfField: "FourNTOther", label: "4NT Other", multiline: true },
      { pdfField: "SlamNotes_1", label: "Slam notes 1", multiline: true },
      { pdfField: "SlamNotes_2", label: "Slam notes 2", multiline: true },
      { pdfField: "SlamNotes_3", label: "Slam notes 3", multiline: true },
    ],
  },
  {
    id: "sec_8",
    title: "7. OTHER CONVENTIONS & DEFENCE",
    items: [
      { pdfField: "Other_0", label: "Other conventions — Other_0", multiline: true },
      { pdfField: "Other_1_1", label: "Other conventions — Other_1_1", multiline: true },
      { pdfField: "Other_2_1", label: "Other conventions — Other_2_1", multiline: true },
      { pdfField: "Other_1_2", label: "Other conventions — Other_1_2", multiline: true },
      { pdfField: "Other_2_2", label: "Other conventions — Other_2_2", multiline: true },
      { pdfField: "Other_1_3", label: "Other conventions — Other_1_3", multiline: true },
      { pdfField: "Other_2_3", label: "Other conventions — Other_2_3", multiline: true },
      { pdfField: "Other_1_4", label: "Other conventions — Other_1_4", multiline: true },
      { pdfField: "Other_2_4", label: "Other conventions — Other_2_4", multiline: true },
      { pdfField: "Other_1_5", label: "Other conventions — Other_1_5", multiline: true },
      { pdfField: "Other_2_5", label: "Other conventions — Other_2_5", multiline: true },
      { pdfField: "MoreNotes_1", label: "Additional notes (MoreNotes_1)", multiline: true },
      { pdfField: "MoreNotes_2", label: "Additional notes (MoreNotes_2)", multiline: true },
      { pdfField: "MoreNotes_3", label: "Additional notes (MoreNotes_3)", multiline: true },
      { pdfField: "MoreNotes_4", label: "Additional notes (MoreNotes_4)", multiline: true },
      { pdfField: "Conventions_0", label: "Defence / other conventions (overview)", multiline: true },
      { pdfField: "UnusualNoTrump", label: "Unusual 2NT (defence)", multiline: true },
      { pdfField: "FourthSuitForcing", label: "Fourth suit forcing", multiline: true },
      { pdfField: "CheckbackPriorities", label: "Checkback / priorities", multiline: true },
      { pdfField: "Defence3NT", label: "Defence3 N T", multiline: true },
      { pdfField: "DefenceOpening2", label: "Defence Opening2", multiline: true },
      { pdfField: "DefenceMulti", label: "Defence Multi", multiline: true },
      { pdfField: "DefenceRCO", label: "Defence R C O", multiline: true },
      { pdfField: "DefenceOtherTwos", label: "Defence Other Twos", multiline: true },
      { pdfField: "DefenceStrongC_1", label: "Defence Strong C_1", multiline: true },
      { pdfField: "DefenceStrongC_2", label: "Defence Strong C_2", multiline: true },
      { pdfField: "DefenceStrongC_3", label: "Defence Strong C_3", multiline: true },
      { pdfField: "DefenceStrongC_4", label: "Defence Strong C_4", multiline: true },
      { pdfField: "Over1NTInterf", label: "Over1 N T Interf", multiline: true },
      { pdfField: "LebensohlOther", label: "Lebensohl — other", multiline: true },
      { pdfField: "TakeOutOf4C4D", label: "Take Out Of4 C4 D", multiline: true },
      { pdfField: "TakeOutOf4H", label: "Take Out Of4 H", multiline: true },
      { pdfField: "TakeOutOf4S", label: "Take Out Of4 S", multiline: true },
      { pdfField: "OtherNotes_0", label: "Other notes (OtherNotes_0)", multiline: true },
      { pdfField: "OtherNotes_1", label: "Other notes (OtherNotes_1)", multiline: true },
      { pdfField: "OtherNotes_2", label: "Other notes (OtherNotes_2)", multiline: true },
      { pdfField: "OtherNotes_3", label: "Other notes (OtherNotes_3)", multiline: true },
      { pdfField: "OtherNotes_4", label: "Other notes (OtherNotes_4)", multiline: true },
      { pdfField: "OtherNotes_5", label: "Other notes (OtherNotes_5)", multiline: true },
      { pdfField: "OtherNotes_6", label: "Other notes (OtherNotes_6)", multiline: true },
      { pdfField: "OtherNotes_7", label: "Other notes (OtherNotes_7)", multiline: true },
      { pdfField: "UnusualNTOther", label: "Unusual NT — other", multiline: true },
      { pdfField: "Over1NTInterfMore", label: "Over1 N T Interf More", multiline: true },
    ],
  },
  {
    id: "sec_9",
    title: "Tick-box style fields (if used)",
    items: [
      { pdfField: "IsNTCheckback", label: "NTCheckback (yes/no / describe)", multiline: true },
      { pdfField: "Is4thForcingGame", label: "4thForcingGame (yes/no / describe)", multiline: true },
      { pdfField: "Is4thForcing1Round", label: "4thForcing1Round (yes/no / describe)", multiline: true },
      { pdfField: "IsCueBids", label: "CueBids (yes/no / describe)", multiline: true },
      { pdfField: "IsAskingBids", label: "AskingBids (yes/no / describe)", multiline: true },
      { pdfField: "IsBlackwood", label: "Blackwood (yes/no / describe)", multiline: true },
      { pdfField: "IsGerber", label: "Gerber (yes/no / describe)", multiline: true },
    ],
  },
];

export const TOPIC_ID_TO_PDF_FIELDS = {
  'open-general-style': ['BasicSystem'],
  'open-1minor': ['Open1C', 'Open1D'],
  'open-2level': ['Open2C', 'Open2D', 'Open2H', 'Open2S', 'OpenOther'],
  'resp-1nt': ['Resp1NT2CStyle', 'Resp1NT2D', 'Resp1NT2H', 'Resp1NT2S', 'Resp1NT2NT'],
  'jacoby': ['JumpRaiseMajor'],
  'neg-double': ['NegXLimit'],
};

export function getAllPdfFieldsFromLayout() {
  const out = [];
  ABF_CARD_SECTIONS.forEach((s) => s.items.forEach((i) => out.push(i.pdfField)));
  return out;
}

export function getLabelForPdfField(pdfField) {
  for (const s of ABF_CARD_SECTIONS) {
    const it = s.items.find((i) => i.pdfField === pdfField);
    if (it) return it.label;
  }
  return pdfField;
}

/**
 * Visible-card editor registry.
 * These are the only fields shown in the modern main editor UI.
 * Each field maps to one or more underlying PDF fields and an exact card region.
 */
export const VISIBLE_CARD_SECTIONS = [
  {
    id: "sec_1",
    title: "ABF Nos., names & basic system",
    fields: [
      {
        id: "abf_no_a",
        label: "ABF No (Player A)",
        pdfFields: ["PlayerNo_A"],
        cardRect: { top: 5.9, left: 73.9, width: 6.8, height: 3.0, maxLines: 1 },
      },
      {
        id: "abf_no_b",
        label: "ABF No (Player B)",
        pdfFields: ["PlayerNo_B"],
        cardRect: { top: 5.9, left: 81.1, width: 6.8, height: 3.0, maxLines: 1 },
      },
      {
        id: "name_a",
        label: "Name (Player A)",
        pdfFields: ["PlayerName_A"],
        cardRect: { top: 9.8, left: 73.9, width: 11.9, height: 3.1, maxLines: 1 },
      },
      {
        id: "name_b",
        label: "Name (Player B)",
        pdfFields: ["PlayerName_B"],
        cardRect: { top: 9.8, left: 86.0, width: 11.9, height: 3.1, maxLines: 1 },
      },
      {
        id: "basic_system",
        label: "Basic system",
        pdfFields: ["BasicSystem"],
        cardRect: { top: 13.6, left: 73.9, width: 24.0, height: 3.3, maxLines: 1 },
      },
    ],
  },
  {
    id: "sec_2",
    title: "1. OPENING BIDS",
    fields: [
      {
        id: "open_1c",
        label: "1♣",
        pdfFields: ["Open1C"],
        cardRect: { top: 21.98, left: 53.11, width: 21.46, height: 2.22, maxLines: 1 },
      },
      {
        id: "open_1d",
        label: "1♦",
        pdfFields: ["Open1D"],
        cardRect: { top: 24.63, left: 53.11, width: 21.46, height: 2.22, maxLines: 1 },
      },
      {
        id: "open_1h",
        label: "1♥",
        pdfFields: ["Open1H"],
        cardRect: { top: 21.98, left: 77.25, width: 21.46, height: 2.22, maxLines: 1 },
      },
      {
        id: "open_1s",
        label: "1♠",
        pdfFields: ["Open1S"],
        cardRect: { top: 24.63, left: 77.25, width: 21.46, height: 2.22, maxLines: 1 },
      },
      {
        id: "open_1nt",
        label: "1NT",
        pdfFields: ["Open1NT"],
        quickOptions: ["12-14 balanced", "14-16 balanced", "15-17 balanced"],
        cardRect: { top: 27.27, left: 53.78, width: 30.9, height: 2.22, maxLines: 1 },
      },
      {
        id: "resp_1nt_2c",
        label: "1NT Responses 2♣",
        pdfFields: ["Resp1NT2CStyle"],
        cardRect: { top: 30.32, left: 61.07, width: 37.41, height: 2.22, maxLines: 1 },
      },
      {
        id: "resp_1nt_2d",
        label: "2♦",
        pdfFields: ["Resp1NT2D"],
        cardRect: { top: 32.96, left: 54.45, width: 20.67, height: 2.22, maxLines: 1 },
      },
      {
        id: "resp_1nt_2h",
        label: "2♥",
        pdfFields: ["Resp1NT2H"],
        cardRect: { top: 35.61, left: 54.45, width: 20.67, height: 2.22, maxLines: 1 },
      },
      {
        id: "resp_1nt_2s",
        label: "2♠",
        pdfFields: ["Resp1NT2S"],
        cardRect: { top: 32.96, left: 77.81, width: 20.67, height: 2.22, maxLines: 1 },
      },
      {
        id: "resp_1nt_2nt",
        label: "2NT",
        pdfFields: ["Resp1NT2NT"],
        cardRect: { top: 35.61, left: 77.81, width: 20.67, height: 2.22, maxLines: 1 },
      },
      {
        id: "resp_1nt_dbl",
        label: "(Dbl)",
        pdfFields: ["Resp1NTDoubled"],
        cardRect: { top: 38.25, left: 54.0, width: 20.89, height: 2.22, maxLines: 1 },
      },
      {
        id: "resp_1nt_other",
        label: "other",
        pdfFields: ["Resp1NTOther"],
        cardRect: { top: 38.25, left: 77.59, width: 20.89, height: 2.22, maxLines: 1 },
      },
      {
        id: "open_2c",
        label: "2♣",
        pdfFields: ["Open2C"],
        cardRect: { top: 41.45, left: 53.11, width: 45.6, height: 2.22, maxLines: 1 },
      },
      {
        id: "open_2d",
        label: "2♦",
        pdfFields: ["Open2D"],
        cardRect: { top: 44.09, left: 53.11, width: 45.6, height: 2.22, maxLines: 1 },
      },
      {
        id: "open_2h",
        label: "2♥",
        pdfFields: ["Open2H"],
        cardRect: { top: 46.73, left: 53.11, width: 45.6, height: 2.22, maxLines: 1 },
      },
      {
        id: "open_2s",
        label: "2♠",
        pdfFields: ["Open2S"],
        cardRect: { top: 49.37, left: 53.11, width: 45.6, height: 2.22, maxLines: 1 },
      },
      {
        id: "open_2nt",
        label: "2NT",
        pdfFields: ["Open2NT"],
        cardRect: { top: 52.01, left: 53.56, width: 21.01, height: 2.22, maxLines: 1 },
      },
      {
        id: "open_3nt",
        label: "3NT",
        pdfFields: ["Open3NT"],
        cardRect: { top: 52.01, left: 77.69, width: 21.01, height: 2.22, maxLines: 1 },
      },
      {
        id: "open_other",
        label: "other",
        pdfFields: ["OpenOther"],
        cardRect: { top: 54.66, left: 53.5, width: 45.3, height: 2.4, maxLines: 1 },
      },
    ],
  },
  {
    id: "sec_3",
    title: "2. PRE-ALERTS",
    fields: [
      {
        id: "prealerts_notes",
        label: "Pre-alert notes",
        pdfFields: ["PreAlert_0", "PreAlert_1_1", "PreAlert_2_1"],
        cardRect: { top: 61.4, left: 58.3, width: 39.2, height: 6.0, maxLines: 2 },
      },
    ],
  },
  {
    id: "sec_4",
    title: "3. COMPETITIVE BIDS / OVERCALLS",
    fields: [
      {
        id: "doubles_1",
        label: "Doubles",
        pdfFields: ["Doubles_1"],
        cardRect: { top: 70.51, left: 55.38, width: 29.98, height: 2.22, maxLines: 1 },
      },
      {
        id: "neg_x_limit",
        label: "Negative double through",
        pdfFields: ["NegXLimit"],
        cardRect: { top: 70.51, left: 93.47, width: 5.23, height: 2.22, maxLines: 1 },
      },
      {
        id: "doubles_2",
        label: "Responsive doubles",
        pdfFields: ["Doubles_2"],
        cardRect: { top: 73.15, left: 51.17, width: 34.18, height: 2.22, maxLines: 1 },
      },
      {
        id: "resp_x_limit",
        label: "Responsive through",
        pdfFields: ["RespXLimit"],
        cardRect: { top: 73.15, left: 94.54, width: 4.17, height: 2.22, maxLines: 1 },
      },
      {
        id: "jump_overcall",
        label: "Jump overcalls",
        pdfFields: ["JumpOvercall"],
        cardRect: { top: 75.79, left: 57.51, width: 18.62, height: 2.22, maxLines: 1 },
      },
      {
        id: "unusual_nt",
        label: "Unusual NT",
        pdfFields: ["UnusualNT"],
        cardRect: { top: 75.79, left: 83.2, width: 15.51, height: 2.22, maxLines: 1 },
      },
      {
        id: "overcall_1nt",
        label: "1NT overcall (immediate)",
        pdfFields: ["Overcall1NT"],
        cardRect: { top: 78.43, left: 61.56, width: 15.61, height: 2.22, maxLines: 1 },
      },
      {
        id: "reopen_1nt",
        label: "1NT overcall (re-opening)",
        pdfFields: ["Reopen1NT"],
        cardRect: { top: 78.43, left: 83.1, width: 15.61, height: 2.22, maxLines: 1 },
      },
      {
        id: "immed_cue_minor",
        label: "Immediate cue (minor)",
        pdfFields: ["ImmedCueMinor"],
        cardRect: { top: 81.08, left: 60.8, width: 16.98, height: 2.22, maxLines: 1 },
      },
      {
        id: "immed_cue_major",
        label: "Immediate cue (major)",
        pdfFields: ["ImmedCueMajor"],
        cardRect: { top: 81.08, left: 81.72, width: 16.99, height: 2.22, maxLines: 1 },
      },
      {
        id: "compete_weak2",
        label: "Over weak twos",
        pdfFields: ["CompeteWeak2"],
        cardRect: { top: 83.72, left: 59.47, width: 13.77, height: 2.22, maxLines: 1 },
      },
      {
        id: "compete_open3",
        label: "Opening threes",
        pdfFields: ["CompeteOpen3"],
        cardRect: { top: 83.72, left: 80.66, width: 18.04, height: 2.22, maxLines: 1 },
      },
      {
        id: "transfers_1",
        label: "Opponent's transfers",
        pdfFields: ["Transfers_1"],
        cardRect: { top: 86.36, left: 60.14, width: 38.57, height: 2.22, maxLines: 1 },
      },
      {
        id: "compete_1nt_1",
        label: "Opponent's 1NT",
        pdfFields: ["Compete1NT_1"],
        cardRect: { top: 88.91, left: 58.62, width: 40.08, height: 2.22, maxLines: 1 },
      },
      {
        id: "compete_1nt_2",
        label: "Opponent's 1NT (cont.)",
        pdfFields: ["Compete1NT_2"],
        cardRect: { top: 91.55, left: 51.17, width: 47.53, height: 2.22, maxLines: 1 },
      },
      {
        id: "compete_1nt_3",
        label: "Opponent's 1NT (cont.)",
        pdfFields: ["Compete1NT_3"],
        cardRect: { top: 94.19, left: 51.17, width: 47.53, height: 2.22, maxLines: 1 },
      },
    ],
  },
  {
    id: "sec_5",
    title: "4. BASIC RESPONSES",
    fields: [
      {
        id: "basic_response_style",
        label: "Basic responses",
        pdfFields: ["BasicResponses_0"],
        cardRect: { top: 1.96, left: 22.61, width: 26.15, height: 2.22, maxLines: 1 },
      },
      {
        id: "jump_raise_minor",
        label: "Jump raises - minors",
        pdfFields: ["JumpRaiseMinor"],
        cardRect: { top: 4.6, left: 9.74, width: 39.03, height: 2.22, maxLines: 1 },
      },
      {
        id: "jump_raise_major",
        label: "Jump raises - majors",
        pdfFields: ["JumpRaiseMajor"],
        cardRect: { top: 7.24, left: 9.74, width: 39.03, height: 2.22, maxLines: 1 },
      },
      {
        id: "minor_jump_shift",
        label: "Jump shifts after minor opening",
        pdfFields: ["MinorJumpShift"],
        cardRect: { top: 9.88, left: 13.95, width: 34.82, height: 2.22, maxLines: 1 },
      },
      {
        id: "major_jump_shift",
        label: "Jump shifts after major opening",
        pdfFields: ["MajorJumpShift"],
        cardRect: { top: 12.52, left: 13.95, width: 34.82, height: 2.22, maxLines: 1 },
      },
      {
        id: "response_strong_2",
        label: "Responses to strong 2 open",
        pdfFields: ["ResponseStrong2"],
        cardRect: { top: 15.17, left: 13.95, width: 34.82, height: 2.22, maxLines: 1 },
      },
      {
        id: "response_2nt",
        label: "Responses to 2NT opening",
        pdfFields: ["Response2NT"],
        cardRect: { top: 17.81, left: 13.95, width: 34.82, height: 2.22, maxLines: 1 },
      },
    ],
  },
  {
    id: "sec_6",
    title: "5. PLAY CONVENTIONS",
    fields: [
      {
        id: "play_priorities",
        label: "Show priorities",
        pdfFields: ["PlayConventions_0"],
        cardRect: { top: 20.73, left: 23.79, width: 24.97, height: 2.22, maxLines: 1 },
      },
      {
        id: "seq_lead_s",
        label: "Leads: Sequences (Suit)",
        pdfFields: ["SeqLead_S"],
        cardRect: { top: 25.62, left: 13.15, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "seq_lead_nt",
        label: "Leads: Sequences (NoTrump)",
        pdfFields: ["SeqLead_NT"],
        cardRect: { top: 25.62, left: 31.33, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "four_honour_s",
        label: "Four or more with an honour (Suit)",
        pdfFields: ["FourHonourLead_S"],
        cardRect: { top: 28.27, left: 13.15, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "four_honour_nt",
        label: "Four or more with an honour (NoTrump)",
        pdfFields: ["FourHonourLead_NT"],
        cardRect: { top: 28.27, left: 31.33, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "four_small_s",
        label: "From 4 small (Suit)",
        pdfFields: ["FourSmallLead_S"],
        cardRect: { top: 30.91, left: 13.15, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "four_small_nt",
        label: "From 4 small (NoTrump)",
        pdfFields: ["FourSmallLead_NT"],
        cardRect: { top: 30.91, left: 31.33, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "three_small_s",
        label: "From 3 cards (no honour) (Suit)",
        pdfFields: ["ThreeSmallLead_S"],
        cardRect: { top: 33.55, left: 13.15, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "three_small_nt",
        label: "From 3 cards (no honour) (NoTrump)",
        pdfFields: ["ThreeSmallLead_NT"],
        cardRect: { top: 33.55, left: 31.33, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "partner_suit_s",
        label: "In partner's suit (Suit)",
        pdfFields: ["LeadPartnersSuit_S"],
        cardRect: { top: 36.21, left: 13.15, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "partner_suit_nt",
        label: "In partner's suit (NoTrump)",
        pdfFields: ["LeadPartnersSuit_NT"],
        cardRect: { top: 36.21, left: 31.33, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "discard_s",
        label: "Discards (Suit)",
        pdfFields: ["DiscardType_S"],
        cardRect: { top: 38.83, left: 13.15, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "discard_nt",
        label: "Discards (NoTrump)",
        pdfFields: ["DiscardType_NT"],
        cardRect: { top: 38.83, left: 31.33, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "count_s",
        label: "count (Suit)",
        pdfFields: ["CountType_S"],
        cardRect: { top: 41.48, left: 13.15, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "count_nt",
        label: "count (NoTrump)",
        pdfFields: ["CountType_NT"],
        cardRect: { top: 41.48, left: 31.33, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "signal_partner_s",
        label: "Signal on partner's lead (Suit)",
        pdfFields: ["SignalPartnerLead_S"],
        cardRect: { top: 44.14, left: 13.15, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "signal_partner_nt",
        label: "Signal on partner's lead (NoTrump)",
        pdfFields: ["SignalPartnerLead_NT"],
        cardRect: { top: 44.14, left: 31.33, width: 17.43, height: 2.22, maxLines: 1 },
      },
      {
        id: "signal_declarer",
        label: "Signal on declarer's lead",
        pdfFields: ["SignalDeclarerLead"],
        cardRect: { top: 46.78, left: 13.13, width: 35.63, height: 2.22, maxLines: 1 },
      },
      {
        id: "play_notes_1",
        label: "Notes 1",
        pdfFields: ["PlayNotes_1"],
        cardRect: { top: 49.42, left: 4.81, width: 43.96, height: 2.22, maxLines: 1 },
      },
      {
        id: "play_notes_2",
        label: "Notes 2",
        pdfFields: ["PlayNotes_2"],
        cardRect: { top: 52.06, left: 1.23, width: 47.53, height: 2.22, maxLines: 1 },
      },
      {
        id: "play_notes_3",
        label: "Notes 3",
        pdfFields: ["PlayNotes_3"],
        cardRect: { top: 54.71, left: 1.23, width: 47.53, height: 2.22, maxLines: 1 },
      },
    ],
  },
  {
    id: "sec_7",
    title: "6. SLAM CONVENTIONS",
    fields: [
      {
        id: "gerber_when",
        label: "4C Gerber",
        pdfFields: ["GerberWhen"],
        cardRect: { top: 57.35, left: 32.67, width: 16.1, height: 2.22, maxLines: 1 },
      },
      {
        id: "rkcb_style",
        label: "RKCB",
        pdfFields: ["RKCBStyle"],
        cardRect: { top: 59.99, left: 15.11, width: 6.93, height: 2.22, maxLines: 1 },
      },
      {
        id: "four_nt_other",
        label: "4NT Other",
        pdfFields: ["FourNTOther"],
        cardRect: { top: 59.99, left: 22.83, width: 25.93, height: 2.22, maxLines: 1 },
      },
      {
        id: "slam_notes_1",
        label: "Slam notes 1",
        pdfFields: ["SlamNotes_1"],
        cardRect: { top: 62.63, left: 16.2, width: 32.56, height: 2.22, maxLines: 1 },
      },
      {
        id: "slam_notes_2",
        label: "Slam notes 2",
        pdfFields: ["SlamNotes_2"],
        cardRect: { top: 65.27, left: 1.23, width: 47.53, height: 2.22, maxLines: 1 },
      },
      {
        id: "slam_notes_3",
        label: "Slam notes 3",
        pdfFields: ["SlamNotes_3"],
        cardRect: { top: 67.92, left: 1.23, width: 47.53, height: 2.22, maxLines: 1 },
      },
    ],
  },
  {
    id: "sec_8",
    title: "7. OTHER CONVENTIONS & DEFENCE",
    fields: [
      {
        id: "other_0",
        label: "Other conventions — line 1",
        pdfFields: ["Other_0"],
        cardRect: { top: 76.0, left: 1.8, width: 42.2, height: 2.35, maxLines: 1 },
      },
      {
        id: "other_1_1",
        label: "Line 2 — left",
        pdfFields: ["Other_1_1"],
        cardRect: { top: 78.35, left: 1.8, width: 21.0, height: 2.35, maxLines: 1 },
      },
      {
        id: "other_2_1",
        label: "Line 2 — right",
        pdfFields: ["Other_2_1"],
        cardRect: { top: 78.35, left: 23.0, width: 21.0, height: 2.35, maxLines: 1 },
      },
      {
        id: "other_1_2",
        label: "Line 3 — left",
        pdfFields: ["Other_1_2"],
        cardRect: { top: 80.7, left: 1.8, width: 21.0, height: 2.35, maxLines: 1 },
      },
      {
        id: "other_2_2",
        label: "Line 3 — right",
        pdfFields: ["Other_2_2"],
        cardRect: { top: 80.7, left: 23.0, width: 21.0, height: 2.35, maxLines: 1 },
      },
      {
        id: "other_1_3",
        label: "Line 4 — left",
        pdfFields: ["Other_1_3"],
        cardRect: { top: 83.05, left: 1.8, width: 21.0, height: 2.35, maxLines: 1 },
      },
      {
        id: "other_2_3",
        label: "Line 4 — right",
        pdfFields: ["Other_2_3"],
        cardRect: { top: 83.05, left: 23.0, width: 21.0, height: 2.35, maxLines: 1 },
      },
      {
        id: "other_1_4",
        label: "Line 5 — left",
        pdfFields: ["Other_1_4"],
        cardRect: { top: 85.4, left: 1.8, width: 21.0, height: 2.35, maxLines: 1 },
      },
      {
        id: "other_2_4",
        label: "Line 5 — right",
        pdfFields: ["Other_2_4"],
        cardRect: { top: 85.4, left: 23.0, width: 21.0, height: 2.35, maxLines: 1 },
      },
      {
        id: "other_1_5",
        label: "Line 6 — left",
        pdfFields: ["Other_1_5"],
        cardRect: { top: 87.75, left: 1.8, width: 21.0, height: 2.35, maxLines: 1 },
      },
      {
        id: "other_2_5",
        label: "Line 6 — right",
        pdfFields: ["Other_2_5"],
        cardRect: { top: 87.75, left: 23.0, width: 21.0, height: 2.35, maxLines: 1 },
      },
    ],
  },
  {
    id: "p2_responses",
    title: "PAGE 2: RESPONSES",
    page: 2,
    fields: page2Fields.responses,
  },
  {
    id: "p2_defence",
    title: "PAGE 2: OTHER METHODS",
    page: 2,
    fields: page2Fields.defence,
  },
];

export function getVisibleSectionById(sectionId) {
  return VISIBLE_CARD_SECTIONS.find((s) => s.id === sectionId);
}

export function getVisibleFieldValue(abfValues, visibleField) {
  const first = (visibleField.pdfFields || [])
    .map((f) => String(abfValues[f] || "").trim())
    .find(Boolean);
  return first || "";
}

export function setVisibleFieldValue(abfValues, visibleField, value) {
  const text = String(value || "");
  const next = { ...abfValues };
  (visibleField.pdfFields || []).forEach((f) => {
    next[f] = text;
  });
  return next;
}